const ko = {
  translation: {
    //home
    home: "홈",
    vehicles: "차량",
    sign_in: "로그인",
    plan_you_trip: "여행 계획을 세우세요",
    save_big: "우리의 저렴한 자동차 렌터카로 크게 절약하세요!",
    with_our_car: "우리의 저렴한 차량 대여로!",
    save_big_desc: "꿈의 차를 대여하세요. 저렴한 가격, 무제한 주행 거리, 유연한 픽업 옵션 등을 이용하세요.",
    book_ride: "탑승 예약",
    learn_more: "더 알아보기",
    book_a_car: "차량 예약",
    without_driver: "운전자 없음",
    with_driver: "운전자와 함께",
    select_booking_type: "예약 유형 선택",
    self_drive: "셀프 주행",
    tour: "투어 / 일일 대여",
    transfer_service: "이송 서비스",
    pickup_date: "수령 날짜",
    dropoff_date: "반납 날짜",
    pickup_location: "수령 위치",
    dropoff_location: "반납 위치",
    book_now: "지금 예약",
    the_price_exclude: "가격에는 운전사 수수료가 포함되지 않으며 별도의 요금이 부과됩니다",
    select_tour_package: "투어 패키지 선택",
    select_duration: "기간 선택",
    destination_location: "목적지 위치",
    quick_and_easy: "빠르고 쉬운 자동차 대여",
    select_car: "차량 선택",
    we_offer: "모든 주행 요구에 맞는 다양한 차량을 제공합니다. 귀하의 요구에 맞는 완벽한 차량을 찾아보세요",
    contact_operator: "운영자에게 문의",
    our_knowlage: "지식 있는 운영자가 언제나 도움을 드릴 준비가 되어 있습니다",
    let_drive: "드라이브하십시오",
    whether_you: "열린 도로를 달리고 계신지 여부에 관계없이 저희의 다양한 차량으로 여행을 즐기세요",
    vehicle_models: "차량 모델",
    our_rental_fleet: "대여 차량 목록",
    choose_from: "다음 모험 또는 비즈니스 여행을 위해 대여할 수 있는 다양한 우수한 차량 중에서 선택하세요",
    reserve_now: "지금 예약",
    save_big_bottom: "저희 저렴한 자동차 대여로 크게 절약하세요!",
    top_airport: "최고의 공항. 현지 공급자. ",
    support: "지원",
    why_choose_use: "왜 저희를 선택해야 할까요",
    best_valued: "당신이 찾을 수 있는 최고 가치의 거래",
    discover_the_best:
      "무법한 특가로 당신이 찾을 수 있는 최고의 거래를 발견하세요. 우리는 당신이 돈을 낭비하지 않고 최고 품질의 서비스와 제품을 즐길 수 있도록 헌신하고 있으며, 당신이 크게 절약할 기회를 놓치지 마십시오.",
    find_details: "자세한 내용 찾기",
    cross_city: "도시 간 드라이브",
    take_your_driving: "우리의 일류 차량으로 국가간 모험을 즐기세요.",
    all_inclusive: "모든 포함된 가격",
    get_everything: "우리의 모든 포함된 가격 정책으로 편리하고 투명한 가격으로 모든 것을 얻으세요.",
    no_hidden: "숨겨진 비용 없음",
    enjoy_peace: "숨겨진 비용 없음 정책으로 마음의 평화를 누리세요. 우리는 투명하고 정직한 가격 정책을 지지합니다.",
    review_by_people: "사람들에 의한 리뷰",
    client_testimonial: "고객의 증언",
    client_testimonial_desc:
      "우리의 고객들이 증언을 통해 어떤 긍정적인 영향을 받았는지 알아보세요. 고객들은 우리의 서비스와 결과를 경험했으며 그들은 당신과 긍정적인 경험을 나누고 싶어합니다.",
    testi_aris:
      "정말 좋아합니다. 서비스는 시간에 맞게 도착하고 길을 아는 운전사처럼 멋지다. 매우 만족스럽고, 이 서비스는 정말 멋집니다. 차량도 그렇습니다. 깨끗하게 냄새 나고 모든 것이 원활하게 진행됩니다. Mas Yoyok (운전사)을 성공하고 건강하게 유지하십시오. 어찌되었든 성공입니다.",
    testi_solomon:
      "저는 Avanza, 2016 타입 G를 빌렸습니다. 차량에는 문제가 없었고 엔진은 부드럽고 차량 본체는 깔끔하게 등록되었으며 가장 중요한 것은 차량을 빌릴 때 WA 팀/그룹이 즉시 문서를 준비한 준비가되어 있었다는 점입니다. ... 요청 된 문서 ... 그것은 멋졌다. 주요한 것은.",
    faq: "자주 묻는 질문",
    frequently_asked: "자주 묻는 질문",
    frequently_asked_desc:
      "당사 웹 사이트에서 자동차 대여 예약 프로세스에 관한 자주 묻는 질문: 공통 관심사 및 질문에 대한 답변.",
    what_is_special: "1. 자동차 대여 거래를 비교하는 것에 특별한 점은 무엇인가요?",
    what_is_special_desc:
      "자동차 대여 거래를 비교하는 것은 예산과 요구 사항에 맞는 최상의 거래를 찾는 데 중요합니다. 다양한 옵션을 비교하여 더 낮은 가격, 추가 서비스 또는 더 나은 차량 모델을 제공하는 거래를 찾을 수 있으므로 돈을 가장 많이 얻을 수 있습니다. 여러 다른 대여 회사에서 온라인으로 조사하고 가격을 비교하여 자동차 대여 거래를 찾을 수 있습니다.",
    how_do_2: "2. 어떻게 자동차 대여 거래를 찾을 수 있나요?",
    how_do_2_desc:
      "여러 다른 대여 회사에서 온라인으로 조사하고 가격을 비교하여 자동차 대여 거래를 찾을 수 있습니다. Expedia, Kayak 및 Travelocity와 같은 웹 사이트를 사용하여 가격을 비교하고 사용 가능한 대여 옵션을 볼 수 있습니다. 또한 특별 거래 또는 프로모션에 대한 정보를 얻기 위해 이메일 뉴스 레터를 가입하고 대여 자동차 회사를 소셜 미디어에서 팔로우하는 것이 좋습니다.",
    how_do_3: "3. 어떻게 저렴한 자동차 대여 가격을 찾을 수 있나요?",
    how_do_3_desc:
      "사전 예약: 자동차 대여를 사전 예약하는 것은 종종 더 낮은 가격을 얻을 수 있습니다. 여러 회사에서 가격 비교: Kayak, Expedia 또는 Travelocity와 같은 웹 사이트를 사용하여 여러 대여 자동차 회사에서 가격을 비교하십시오. 할인 코드 및 쿠폰 찾기: 대여 가격을 낮추기 위해 사용할 수 있는 할인 코드와 쿠폰을 찾으십시오. 공항 외부 위치에서 대여하는 것은 때로는 가격이 더 저렴할 수 있습니다.",
    reservation_12: "예약은 적어도 12시간 전에 해야 합니다",
    reservation_24: "예약은 적어도 24시간 전에 해야 합니다",
    drop_after_pickup: "반납 날짜는 픽업 날짜 이후여야 합니다",
    //car card
    daily_rate_from: "일일 요금",
    includes: "포함",
    isurances_etc: "보험, 고객 서비스",
    more_info: "자세한 내용",
    efficient: "효율적",
    safe: "안전",
    economical: "경제적",
    //select vehicle
    book_car_by_getting: "문의하여 차량 예약",
    select_vehicle: "차량 선택",
    complete_reservation: "예약 완료",
    upon_completing: "이 예약 문의를 완료하면 다음을 받게 됩니다.",
    your_rent_voucher: "렌탈 바우처, 렌탈 데스크에서 제시해야 하며 무료 고객 지원 번호가 함께 제공됩니다.",
    location_n_date: "장소 및 날짜",
    car: "차량",
    pickup_date_n_time: "픽업 날짜 및 시간",
    dropoff_date_n_time: "반납 날짜 및 시간",
    prices: "가격",
    additional_items: "추가 항목",
    umbrella: "우산",
    baby_seat: "유아용 시트",
    insurance: "보험",
    full_covered: "풀 커버 보험",
    wedding: "웨딩카",
    flower_arrangement: "꽃 꾸미기 (웨딩 카)",
    additional_stop: "추가적인 정거장",
    flower_bouquet: "꽃다발",
    all_in_one_for: "톨 및 주차",
    price_estimate: "가격 견적",
    estimate_total: "총 견적",
    the_price_does_not: "가격에는 톨 게이트 비용, 주차비, 팁이 포함되지 않습니다",
    the_price_includes: "가격에는 휘발유, 통행료, 주차비, 봉사료가 포함되어 있지 않습니다.",
    personal_info: "개인 정보",
    identity_type: "신분증 유형",
    select_identity: "신분증 선택",
    identity_image: "신분증 이미지",
    choose_file: "파일 선택",
    sim_or: "SIM 카드 / 운전 면허증",
    name: "이름",
    booker_name: "예약자 이름",
    enter_booker_name: "주문자 이름을 입력하세요",
    enter_name: "이름을 입력하세요",
    whatsapp_number: "WhatsApp 번호",
    enter_whatsapp_number: "WhatsApp 번호를 입력하세요",
    email: "이메일",
    enter_email: "이메일 주소를 입력하세요",
    address: "주소",
    enter_address: "주소를 입력하세요",
    emergency_contact_1: "긴급 연락처 1",
    emergency_contact_2: "긴급 연락처 2",
    enter_emergency: "긴급 연락처를 입력하세요",
    return_flight: "귀국 항공편 예약",
    hotel_accomodation: "숙박",
    notes: "참고 사항",
    enter_notes: "참고 사항을 입력하세요",
    we_will_ask: "필요한 경우 추가 데이터를 요청할 것입니다.",
    rental_policy: "대여 정책",
    in_town_usage: "도시 내 사용",
    add_outside_island: "섬 외부 사용 추가",
    outside_island_usage: "섬 외부 사용",
    for_self_drive: " 섬 외부 사용 (셀프 드라이브용)",
    denpasar_jimbaran_etc: "덴파사르, 짐바란, 레기안, 누사 두아, 울루와투, 우붓 센터, 세민야크.",
    out_of_town_usage: "도시 밖 사용",
    zone_1: "지역 1",
    zone_2: "지역 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (fee depends on car type)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (fee depends on car type)",
    this_rate_valid: "이 요금은 단방향으로만 적용됩니다.",
    add_out_off_town: "도시 밖 사용 추가",
    select_date: "날짜 선택",
    select_travel_date: "도시 밖 여행 날짜 선택",
    select_travel_date_island: "섬 외부의 여행 날짜를 선택하십시오",
    total: "총액",
    close: "닫기",
    add: "추가",
    loading: "로딩 중...",
    // customer form
    additional_information: "추가 정보 (선택 사항)",
    guest_name: "투숙객 이름",
    driver_name: "운전자 이름",
    passanger_total: "승객 총 수",
    luggage_total: "수하물 총 수",
    flight_detail: "항공편 세부 정보",
    airline_name: "예시: 항공사 이름: 가루다, 도착 시간: 17:00",
    hotel_detail: "호텔/숙박 시설 세부 정보",
    hotel_name: "예시: 호텔 이름: 인다 호텔",
    disability_needs: "장애인 필요 사항",
    wheelchair: "예시: 휠체어: 1",
    the_price_varies: "가격은 목적지 위치에 따라 다릅니다.",
    including_petrol: "톨게이트, 주차료 포함",
    change: "변경",
    setting_date_use: "사용 날짜 설정",
    date: "날짜",
    //detail vehicle
    detail_vehicle: "차량 상세 정보",
    price_type: "가격 유형",
    price: "가격",
    area: "지역",
    yes: "예",
    trunk: "트렁크",
    customer_service: "고객 서비스",
    insurances: "보험",
    with_a_professional:
      "전문적이고 포괄적인 판매 후 서비스로 인해 우리 팀의 좋은 지원으로 편안하게 쉴 수 있습니다. 이 차량을 주문할 때 다양한 매력적인 제안과 특별 프로모션을 활용할 수도 있습니다.",
    select_this_car: "이 차량 선택",
    //global
    save: "저장",
    big: "크게",
    days: "일",
    hour: "시간",
    brand: "브랜드",
    year: "년",
    seat: "좌석",
    ac: "에어컨",
    color: "색",
    transmission: "변속기",
    fuel: "연료",
    company: "회사",
    working_hour: "근무 시간",

    //privacy and policy
    privacy_and_police: "개인 정보 및 정책",
    for_overtime:
      "초과 근무에 대해서는 초과 근무 시간당 50,000 루피아의 비용이 부과됩니다 (2시간을 초과하는 경우 1일로 계산됩니다).",
    for_extension:
      "2 회 이상 임대 연장의 경우 Wirasana Rent A Car Denpasar 사무실에서 확인 및 확인하십시오. 주소 : Jl. Bypass Ngurah Rai No.162, Sanur Kaja, 남 덴파사르.",
    unit_vehicles:
      "임대 차량은 계약을 체결 한 임차인 이외에는 양도 / 사용 할 수 없으며 (차량을 증거물로 사용하는 경우 일일 임대료가 부과됨)。",
    reschedule_or:
      "예약 일정에서 1x24 시간 미만으로 통지 된 경우 수령 / 반환 단위의 재 스케줄을 확인하거나 변경할 수 없으며 운영 설정 오류를 피하기 위한 조치입니다.",
    reschedule_date:
      "수령 단위 / 반환 단위의 날짜 또는 시간을 변경하려면 최대 2 회의 변경을 허용하며 75,000 루피아의 비용이 발생합니다.",
    for_lose_umbrella: "임대 기간 동안 우산을 잃어 버린 경우 우산 1 개당 100,000 루피아의 비용이 부과됩니다.",
    for_lose_baby_seat:
      "임대 기간 동안 베이비 카시트를 잃어 버린 경우 베이비 카시트 1 개당 2,000,000 루피아의 비용이 부과됩니다.",
    usage_unit: "차량은 발리 지역에서만 사용할 수 있습니다.",
    lose_stnk: "STNK를 잃어 버린 경우 1,500,000 루피아의 비용이 부과됩니다.",
    lose_plat: "플레이트를 잃어 버린 경우 250,000 루피아의 비용이 부과됩니다.",
    for_damage_ban:
      "아스팔트 도로 이외에서의 부적절한 사용 또는 사용으로 인한 타이어 손상에 대한 비용으로 타이어 당 700,000 루피아의 비용이 부과됩니다.",
    for_beret: "새로운 흠이있는 경우 이벤트 당 750,000 루피아의 비용이 부과됩니다.",
    towing_fee: "토잉 비용 및 수리 중에 자동차 임대료는 자기 리스크 요금에 포함되지 않습니다.",
    lack_of_petrol: "배달 또는 수령 중에 연료 부족으로 인해 상자 당 100,000 루피아의 비용이 부과됩니다.",
    fuel_in_the_middle: "여행 중 연료가 부족한 경우 도시 내 지역에 대한 처리 비용으로 250,000 루피아가 부과됩니다.",
    smell: "차량 반납 시 두리안 / 구토물 / 담배 / 젖은 시트 냄새가 있는 경우 1,500,000 루피아의 비용이 부과됩니다.",
    dirty_car: "차량이 매우 더러울 경우 150,000 루피아의 청소 비용이 부과됩니다.",
    lost_the_key: "자동차 키를 잃어 버린 경우 1,500,000 루피아의 비용이 부과됩니다.",
    more_than_one_driver: "운전자가 하나 이상인 경우 하루에 ID당 50,000 루피아가 부과됩니다.",
    please_not_park: "차량을 나무 아래 또는 차량 위치를 위협하는 장소에 주차하지 마십시오.",
    charging_error: "연료를 잘못 충전하는 경우 2,500,000 루피아의 수리 비용이 부과됩니다.",
    not_info:
      "임대 기간 동안 차량 수리 요구 사항과 관련된 정보를 제공하지 않으면 동의 / 토론 없이 어떤 작업실에서도 보상을 받지 않습니다.",
    trouble_car:
      "차량에 문제가 발생하는 경우 저희의 기계 팀이 가능한한 최대 4 시간 동안 당신에게 따라가서 도움을 드리겠습니다 (당신의 위치에 따라 최대 4 시간까지 걸릴 수 있음).",
    security_deposit:
      "보증금으로 500,000 루피아가 보류되며 (차량 반납 및 E-Tilang 검사 후 최대 7 일 내에 은행 이체로 보증금이 환불됩니다).",
    basic_usage: "기본 사용은 Traveloka의 지도에 따라 도시 내로 제한됩니다.",
    excess_usage: "12시간 이상 또는 자정 이후의 초과 사용은 Traveloka의 부록/규칙에 따라 추가 요금이 부과됩니다.",
    driver_contact: "운전자는 픽업 위치에 도착하기 직전에 연락을 드릴 것입니다.",
    other_questions: "다른 질문이 있으시면 언제든지 저희에게 문의하세요.",
    pickup_point:
      "Solaria 앞에서 픽업 포인트가 있습니다. 다른 픽업 포인트를 요청하려면이 그룹을 통해 직접 알려주십시오.",
    reschedule_info:
      "예약된 일정 24시간 전에 통지가 없으면 픽업 및 목적지 변경 및 변경 사항을 확인할 수 없습니다. 운영 설정 오류를 방지하기 위해.",
    reschedule_fee: "리스케줄링 수수료가 75,000 IDR (최대 2 회 리스케줄링) 있습니다.",
    reschedule_airline:
      "항공사 변경으로 인한 리스케줄링의 경우 리스케줄 확인을 위한 증거를 첨부하십시오. 그러나 리스케줄링 수단은 리스케줄링 시간의 차량 가용성에 따라 달라집니다.",
    airline_delay:
      "항공사 지연의 경우 지연 증거를 제공하십시오. 우리의 운전자는 최신 일정에 따라 픽업하려고 최선을 다하겠습니다.",
    voucher_usage: "이 바우처는 멈춤 없는 1회 픽업 또는 일방 트립에만 유효합니다.",
    additional_stop_meals: "식사 등 추가 중지는 시간당 100,000 IDR의 추가 비용이 부과됩니다.",
    driver_wait_time:
      "운전자는 30분 동안 기다릴 것입니다. 지정된 시간을 초과하면 시간당 100,000 IDR의 추가 비용이 발생합니다.",
    destination_change: "목적지 변경에 따라 위치에 따라 추가 비용이 부과됩니다.",
    no_eating_drinking: "차량 내에서 날림이 발생할 수 있는 음식과 음료 섭취는 금지됩니다.",
    boarding_landing: "보딩 및 Ngurah Rai 공항에서 착륙하면 반드시 확인하십시오.",
    driver_details: "운전자 세부 정보는 여행 당일에 제공됩니다.",
    mask_and_distance: "항상 마스크를 착용하고 차량 내에서 사회적 거리를 유지하십시오.",
    disinfected_vehicles: "모든 Wirasana 차량은 미리 소독되었습니다.",
    SWAB_driver_charge: "SWAB 운전사의 추가 요금은 필요한 경우 99,000 IDR입니다.",
    passenger: "승객",
    use_the_current_location: "현재 위치 사용",
    cancel: "취소",
    confirm: "확인",
    i_have_read_and_accept: "개인정보 처리방침을 읽고 동의합니다",
    i_accept_the_privacy: "개인정보 처리방침에 동의합니다",
    open_filters: "필터 열기",
    sort: "정렬",
    price_low_to_high: "가격: 낮은 순",
    price_high_to_low: "가격: 높은 순",
    name_a_z: "이름: A → Z",
    name_z_a: "이름: Z → A",
    filters: "필터",
    price_per_day: "하루 요금",
    total_passenger: "총 승객 수",
    drivetrain: "구동 방식",
    clear_all: "모두 지우기",
    apply_filters: "필터 적용",
    search_car: "자동차 검색",
    ready_to_continue_payment: "결제를 계속하시겠습니까?",
    please_review_payment: "계속하기 전에 결제 정보를 확인해주세요.",
    total_amount: "총 결제 금액",
    proceed_to_payment: "결제 진행",
    about: "회사 소개",
    about_company: "회사 정보",
    about_headline: "엔진을 켜면 당신의 모험이 시작됩니다",
    about_description:
      "단순하지만 우리는 최고의 서비스를 제공하기 위해 최선을 다하고 있습니다. 모든 여정이 편안하고 안전하며 즐겁도록 하겠습니다.",
    about_car_types: "차량 종류",
    about_rental_outlets: "렌터카 지점",
    about_repair_shop: "정비소",
    about_book_car: "차량 예약은 저희에게 문의하세요",
    about_phone: "(0361) 286-066",
    language: "언어",
    about_us: "회사 소개",
    contact_us: "문의하기",
    booking_type: "예약 유형",
    the_royal_essence: "여정의 왕실스러운 본질",
    relaxed_journey: "가장 편안한 여행",
    page_title: "연락하기",
    headline: "추가 정보가 필요하신가요?",
    description: "연구, 개발 및 교육 분야에서 15년 이상의 경험을 가진 다재다능한 전문가입니다.",
    phone_label: "전화번호",
    email_label: "이메일",
    address_label: "주소",
    form_name: "전체 이름",
    form_message: "문의 내용을 작성해주세요",
    form_placeholder_name: "예: '김철수'",
    form_placeholder_message: "여기에 작성하세요...",
    form_button: "WhatsApp으로 보내기",
    required_alert: "모든 필수 항목을 입력해주세요!",
    address_value: "덴파사르, 발리",
    why_choose_wirasana: "왜 Wirasana인가요",
    trusted_partner: "발리에서 신뢰할 수 있는 자동차 렌트 파트너",
    experience_excellence: "프리미엄 차량, 탁월한 서비스, 경쟁력 있는 가격으로 최고의 경험을 제공합니다.",
    happy_customers: "만족한 고객",
    vehicles_available: "이용 가능한 차량",
    years_experience: "경험 연수",
    satisfaction_rate: "만족도",
    what_makes_us_different: "우리의 차별점",
    discover_advantages: "경쟁사와 다른 우리의 장점을 확인하세요.",
    comprehensive_insurance: "종합 보험",
    comprehensive_insurance_desc: "모든 렌트에 전면 보험이 포함되어 있습니다. 안심하고 운전하세요.",
    premium_fleet: "프리미엄 차량",
    premium_fleet_desc: "정기적으로 점검된 현대적인 차량으로 최고의 주행 경험을 제공합니다.",
    support_247: "24시간 고객지원",
    support_247_desc: "언제든지 도와드릴 준비가 되어 있습니다.",
    best_price: "최고가 보장",
    best_price_desc: "투명한 가격 정책, 숨겨진 요금 없음.",
    flexible_rental: "유연한 대여 옵션",
    flexible_rental_desc: "시간 단위부터 월 단위까지 자유롭게 선택하세요.",
    free_delivery: "무료 배송",
    free_delivery_desc: "발리 내 원하는 위치에서 무료로 차량을 인도 및 회수합니다.",
    more_reasons: "더 믿을 수 있는 이유",
    trusted_by_thousands: "수천 명이 신뢰한 브랜드",
    trusted_by_thousands_desc: "10,000명 이상의 고객이 저희를 선택했습니다.",
    licensed_insured: "공식 인증 및 보험 가입",
    licensed_insured_desc: "안전하고 믿을 수 있는 차량 운행을 보장합니다.",
    easy_booking: "간편한 예약",
    easy_booking_desc: "몇 분 만에 온라인으로 간단히 예약하세요.",
    flexible_payment: "유연한 결제 방법",
    flexible_payment_desc: "신용카드, 은행 송금 및 디지털 지갑 모두 가능합니다.",
    cta_title: "여행을 시작할 준비가 되셨나요?",
    cta_desc: "지금 바로 차량을 예약하고 Wirasana의 차이를 경험하세요.",
    call_us_now: "지금 전화하기",
    back: "뒤쪽에",
    weather_protection: "야외 활동을 위한 날씨 보호",
    safety_seat_children: "어린이용 안전 좌석 (5–4세)",
    beautiful_flower_arrangements: "특별한 날을 위한 아름다운 꽃 장식",
    extra_stops: "여정 중 추가 정차",
    all_in_one_package: "편의를 위한 올인원 패키지",
    fresh_flower_bouquet: "신선한 꽃다발 구성",
    set_quantity_each_date: "날짜별 수량 설정",
    total_items: "총 항목",
    items: "항목",
    select_all: "모두 선택",
    select_dates_apply_item: "이 항목을 적용할 날짜 선택",
    item_will_be_applied: "항목이 적용됩니다",
    out_of: "중",
    total_day: "총 일수",
    type_or_choose_location: "위치를 입력하거나 목록에서 선택하세요...",
    select_from_map: "지도에서 위치 선택",
    popular_locations: "인기 위치",
    manual_input_hint: "또는 검색창에 위치를 직접 입력하세요",
    common: {
      back: "뒤쪽에",
      back_to_search: "검색으로 돌아가기",
      name: "이름",
      email: "이메일",
      phone: "핸드폰",
      total: "총",
      hours: "시간",
      processing: "처리 중...",
      searching: "수색...",
      error_occurred: "오류가 발생했습니다. ",
      information: "정보",
    },
    booking: {
      detail: "예약 세부정보",
      booking_number: "예약번호{{number}}",
      not_found: "데이터를 찾을 수 없음",
      search_again: "예약 내용을 다시 검색해 주세요",
      type: "예약 유형",
      pickup_date: "픽업 날짜",
      dropoff_date: "하차 날짜",
      price_breakdown: "가격 내역",
      price_date: "가격 ({{date}})",
      fees: "거래 수수료 및 세금",
      delivery_fee: "배송비",
      pickup_fee: "픽업 수수료",
      canceled: "주문 취소됨",
      contact_customer_service: "이 주문은 취소되었습니다. ",
      check_history: "예약 내역 확인",
      enter_details: "주문 세부정보를 보려면 이메일과 예약 코드를 입력하세요.",
      booking_code: "예약 코드",
      code_example: "예: S-0018, T-0025(데모에는 S-0018 사용)",
      check_booking: "예약 확인",
      info_code_sent: "예약 코드는 예약 후 이메일로 전송됩니다",
      info_continue_payment: "미결제 주문에 대한 결제를 계속할 수 있습니다.",
      info_contact_support: "문제가 발생하면 고객 서비스에 문의하세요",
    },
    status: {
      booked: "예약됨",
      prepared: "준비됨",
      operated: "움직이는",
      canceled: "취소",
      success: "성공",
    },
    payment: {
      not_paid: "미지급",
      paid: "유급의",
      partial: "부분결제",
      continue: "계속 결제",
      invoice_not_found: "송장을 찾을 수 없습니다.",
      link_failed: "결제링크 생성에 실패했습니다. ",
      received: "결제 완료",
      total_paid: "지불한 총액: {{amount}}",
    },
    validation: {
      fill_all_fields: "이메일과 예약번호를 입력해주세요",
    },
    manage_booking: "예약 관리",
    booking_confirmation: "예약 확인",
    next: "다음",
    booking_details: "예약 세부정보",
    review_n_confirm: "검토 및 확인",
    booking_success: "예약 성공!",
    booking_success_message: "귀하의 예약이 성공적으로 제출되었습니다. ",
    open_payment_link: "결제 링크 열기",
    required_documents: "필수서류",
    payment_information: "결제정보",
    review_payment_details: "결제내역을 확인하신 후 결제를 진행해주세요.",
    booking_summary: "예약 요약",
    invoice_number: "송장 번호",
    customer_name: "고객 이름",
    payment_instructions: "지불 지침",
    payment_instruction_1: "결제 송장을 생성하려면 아래 버튼을 클릭하세요.",
    payment_instruction_2: "Xendit 결제 페이지로 리디렉션됩니다.",
    payment_instruction_3: "사용 가능한 결제 수단을 사용하여 결제를 완료하세요.",
    payment_instruction_4: "성공적으로 결제한 후 확인 이메일을 받게 됩니다.",
    payment_link_created: "결제 링크가 생성되었습니다!",
    click_below_to_proceed: "아래 버튼을 클릭하시면 결제가 진행됩니다",
    creating_invoice: "송장 생성 중...",
    create_payment_invoice: "결제 송장 생성",
    done: "결제를 완료했어요",
    order_summary: "주문 요약",
    please_review_order: "결제하기 전에 주문 세부 정보를 확인해 주세요",
    customer_information: "고객 정보",
    phone: "전화번호",
    vehicle: "차량",
    rental_period: "대여 기간",
    locations: "위치",
    price_breakdown: "가격 내역",
    base_price: "기본 요금",
    delivery_fee: "배송 요금",
    pickup_fee: "픽업 요금",
    tour_package: "투어 패키지 가격은 다음부터 시작합니다",
    airport_transfer_from: "공항 픽업 서비스 가격은 다음부터 시작합니다",
    tourPackage: "투어 패키지",
    basic_title: "기본 보호",
    basic_subtitle: "렌트에 포함된 기본 보장",
    km_unlimited: "무제한 마일리지",
    own_risk: "사고 당 Rp 750,000의 자체 위험 수수료 포함",
    damage_cover: "충돌, 긁힘, 충격 손상에 대한 보장",
    glass_tire: "타이어 및 유리 보호",
    interior_protect: "내부 보호",
    not_included_towing: "수리 기간이 7일을 초과하는 경우 견인 서비스 및 추가 임대 기간은 포함되지 않습니다.",
    got_it: "알았어요",
    basic_protection: "기본 보호",
    see_more_details: "자세한 내용 보기",
    gps: "GPS",
    gps_desc: "차량 내 내비게이션 시스템.",
    phone_holder: "휴대폰 거치대",
    phone_holder_desc: "안전 운전을 위한 핸즈프리 거치대.",
    family_card: "가족관계증명서",
    business_id: "사업자 등록증",
    social_media: "소셜 미디어",
    customer_info: "고객 정보",
    enter_social_media: "소셜 미디어 입력",
    insurance_subtitle: "포괄적인 보장과 마음의 평화로 여행을 보호하세요",
    included: "포함됨",
    not_included: "포함되지 않음",
    toll_and_parking: "통행료 및 주차",
    toll_and_parking_desc: "통행료·주차 비용",
    your_trusted_mobility: "발리에서 신뢰할 수 있는 모빌리티 파트너",
    wirasana_is_professional:
      "Wirasana Rent A Car는 발리에 기반을 둔 전문 렌터카 서비스로, 여행자와 기업을 위해 신뢰할 수 있고 편안하며 유연한 교통 솔루션을 제공하는 데 전념하고 있습니다. 운송 업계에서 다년간의 경험을 바탕으로, 우리는 이동성이 모든 여정의 필수적인 부분이라는 것을 이해합니다 — 레저, 비즈니스 또는 특별한 행사를 위해서 말이죠.",
    our_mission_is_to_make:
      "우리의 사명은 발리에서의 교통을 간단하고 안전하며 접근하기 쉽게 만드는 것입니다. 우리는 개인 여행을 위한 소형차부터 비즈니스 및 특별 이벤트를 위한 프리미엄 차량에 이르기까지 다양한 요구에 맞는 잘 관리된 차량을 제공합니다.",
    lets_get_you: "함께 길 위로 나서보세요",
    have_questions_about:
      "차량, 가격 또는 이용 가능 여부에 대해 궁금한 점이 있으신가요? 저희 팀이 도와드릴 준비가 되어 있습니다. 발리에서의 휴가, 출장, 또는 특별 이벤트를 계획 중이시라면, 저희가 교통 경험을 원활하고 번거롭지 않게 만들어 드리겠습니다.",
    search_vehicle: "차량 검색",
    vehicle_type: "차량 유형",
    motorcycle: "오토바이",
    all: "전체",
    your_trustedcar_rental_in_bali: "발리에서 신뢰할 수 있는 렌터카",
    simple_booking: "간편한 예약. 믿을 수 있는 차량. 탁월한 서비스.",
    we_provide_flexible:
      "셀프 드라이브, 기사 서비스, 공항 픽업을 포함한 유연한 렌털 솔루션을 제공하여 발리에서의 여행을 손쉽게 만들어 드립니다.",
  },
};

export default ko;
